// Words the whole checkout shares: step names, services, pages, buttons and the
// messages more than one step shows. Spanish: neutral Latin American, "usted".

const en = {
  "common.moreBelow": "Scroll down for more",
  "step.details": "Details",
  "step.options": "Delivery & Extras",
  "step.contact": "Contact",
  "step.payment": "Payment",
  "step.placed": "Order placed",

  "service.certified": "Certified Translation",
  "service.standard": "Standard Translation",
  "service.notarization": "Notarization",
  "service.hardCopy": "Mail Hard Copy",
  "service.signature": "Signature Required for Delivery",
  "service.expedited": "Expedited",
  "service.expeditedPlus": "Expedited Plus",
  "service.standardDelivery": "Standard",

  "summary.title": "SUMMARY",
  "summary.services": "Services",
  "summary.total": "Total",
  "summary.free": "Free",
  "summary.pair": "{from} to {to}",
  "summary.noPages": "0 pages",
  "summary.expeditedTurnaround": "Expedited Turnaround",
  "summary.expeditedPlusTurnaround": "Expedited+ Turnaround",
  "summary.discount": "Discount",
  "summary.code": "code:",

  pages: ({ n }) => `${n} ${parseFloat(n) === 1 ? "page" : "pages"}`,

  "button.continueDelivery": "Continue to Delivery",
  "button.continueContact": "Continue to Contact",
  "button.continuePayment": "Continue to Payment",
  "button.continuing": "Continuing...",
  "button.waitingConnection": "Waiting for connection...",
  "button.backDetails": "Back to Details",
  "button.backDelivery": "Back to Delivery",
  "button.backContact": "Back to Contact",
  "button.save": "Save",
  "button.saving": "Saving...",
  "button.cancel": "Cancel",

  "field.firstName": "First Name",
  "field.lastName": "Last Name",
  "field.email": "Email",
  "email.typoCheck": "Please check your email. Did you mean {fix}?",
  "email.typoFix": "Yes, use it",
  "field.optional": "(optional)",

  "notify.error": "Error",
  "notify.success": "Success",
  "notify.invalidEmail": "Invalid Email",
  "notify.fileRemoved": "File removed",
  "error.generic": "An error ocurred while processing the request. Please, try again. If it persists, contact support.",
  "notify.orderNotSaved": "Your order wasn't saved",
  "notify.quoteNotSent": "Your quote request wasn't sent",
  "error.order.rejected": "Our system didn't accept your order's details. This is a problem on our side, and trying again won't fix it. Write to support@everbary.com and we'll place it for you.",
  "error.order.connection": "We couldn't reach our servers. Check your internet connection and try again. What you entered is still here.",
  "error.order.other": "Something went wrong on our side. Please try again. If it happens again, write to support@everbary.com and we'll place it for you.",
  "error.order.clock": "The date or time on your device is wrong, so our system can't accept your order. Correct it in your device's settings and try again.",
  "notify.slowSave.title": "This is taking longer than usual",
  "notify.slowSave": "Check your internet connection. Keep this page open: we'll continue on our own as soon as it's back.",
  "error.order.number": "We couldn't get an order number from our servers. Check your internet connection and try again. If it happens again, write to support@everbary.com.",
  "error.address.save": "We couldn't save this change to your address. Check your internet connection and try again. If it happens again, write to support@everbary.com.",
  "error.invalidEmail": "The email address is invalid. Please, try again.",
  "error.missingData": "This page lost your order's languages or reference, so it can't continue. Go back to the first step and check your documents and languages.",

  // Data/Functions/orderFiles.js missingFilesMessage
  missingFiles: ({ names }) => {
    const quoted = names.map((name) => `"${name}"`);
    const list = quoted.length > 1 ? `${quoted.slice(0, -1).join(", ")} and ${quoted[quoted.length - 1]}` : quoted[0];
    const many = names.length > 1;
    return `${list} ${many ? "are" : "is"} no longer uploaded, so we removed ${many ? "them" : "it"} from your order. Please upload ${many ? "them" : "it"} again if you need ${many ? "them" : "it"} translated.`;
  },

  // SecureAndPrivate
  "secure.turnaround": "{time} est. turnaround",
  "secure.turnaroundText": "This is an estimate to deliver the digital copy based on the current order information you've provided.",
  "secure.title": "Secure and Private",
  "secure.text": "All data processed by our site, including uploaded files, is encrypted. Only essential staff with signed NDAs can access your information.",
  "secure.help": "Need help?",
  "secure.contactUs": "Contact us",

  // MobileContinueBar
  "bar.total": "Total",

  // SearchSelect / select-search
  "select.search": "Search",
  "select.allLanguages": "All languages",
  "select.noOptions": "No options found",
  "select.youOrderMost": "You order most",
  "select.mostRequested": "Most requested",

  // NewComponents/MoreOptions: a team's folded extras.
  "more.options": "More options",
  ordersCount: ({ n }) => `${n} ${n === 1 ? "order" : "orders"}`,

  // FileUploaderButton
  "upload.select": "Select File",
  "upload.orDrag": "or drag and drop here",
  "upload.orPhoto": "or take a photo",
  "upload.max": "Maximum file size is 50 MB.",
  // A file's row while it uploads (Data/Functions/uploadFile.js).
  "upload.slow": "Your connection seems slow. Still uploading…",
  "upload.stalled": "This upload seems stuck.",
  "upload.failed": "Upload failed.",
  "upload.retry": "Try again",
  "upload.tooBig": "This file is {size} MB, too big to upload (the limit is 50 MB). Please send a smaller or compressed file.",

  // LogoAuthNavbar
  "nav.signOut": "Sign Out",
  "nav.signedOut": "You have signed out.",
  "nav.signOutError": "There was an error signing out. Please, try again.",
  // utility/lazyPage.js ChunkErrorBoundary
  "chunk.failed": "This page could not be loaded. Please check your connection and reload.",
  "chunk.reload": "Reload",

  // What's still missing before Continue (NewComponents/MissingFields.js).
  "missing.intro": "Still needed: {list}",
  "missing.and": "and",
  "missing.more": "and {n} more",
  "missing.field.email": "email",
  "missing.field.validEmail": "a valid email",
  "missing.field.languageFrom": "source language",
  "missing.field.languageTo": "target language",
  "missing.field.files": "files to translate",
  "missing.field.pages": "number of pages",
  "missing.field.firstName": "first name",
  "missing.field.hear": "how you heard about us",
  "missing.field.hearOther": "where you heard about us",
  "missing.field.submittingTo": "who is asking for the translation",
  "missing.field.submittingTo.attorney": "your attorney's name",
  "missing.field.submittingTo.university": "the university's name",
  "missing.field.submittingTo.dmv": "the DMV's state",
  "missing.field.submittingTo.other": "who is asking for it",
  "missing.field.country": "country",
  "missing.field.method": "shipping method",
  "missing.field.state": "state",
  "missing.field.city": "city",
  "missing.field.zip": "ZIP code",
  "missing.field.street": "street address",
  "missing.field.savedAddress": "a saved address",
  "missing.field.addressName": "address name",
  // Under the field a blocked Continue took the customer to (NewComponents/MissingFields.js).
  // A field without its own text gets "Required: {label}".
  "missing.required": "Required: {label}.",
  "missing.error.submittingTo": "Tell us who is asking for this translation.",
  "missing.error.submittingTo-attorney": "Enter the name of the attorney or law firm.",
  "missing.error.submittingTo-university": "Enter the name of the university or school.",
  "missing.error.submittingTo-dmv": "Choose the state of the DMV.",
  "missing.error.submittingTo-other": "Enter who is asking for this translation.",
  "missing.error.firstName": "Enter your first name.",
  "missing.error.hear": "Tell us how you heard about us.",
  "missing.error.files": "Upload the files to translate.",
};

const lower = (name) => (name ? name.charAt(0).toLowerCase() + name.slice(1) : "");

const es = {
  "common.moreBelow": "Continúa más abajo",
  "step.details": "Detalles",
  "step.options": "Entrega y extras",
  "step.contact": "Contacto",
  "step.payment": "Pago",
  "step.placed": "Pedido realizado",

  "service.certified": "Traducción certificada",
  "service.standard": "Traducción estándar",
  "service.notarization": "Notarización",
  "service.hardCopy": "Copia impresa por correo",
  "service.signature": "Firma requerida al entregar",
  "service.expedited": "Urgente",
  "service.expeditedPlus": "Urgente Plus",
  "service.standardDelivery": "Estándar",

  "summary.title": "RESUMEN",
  "summary.services": "Servicios",
  "summary.total": "Total",
  "summary.free": "Gratis",
  // Language names are lowercase inside a sentence in Spanish ("De español a inglés").
  "summary.pair": ({ from, to }) => `De ${lower(from)} a ${lower(to)}`,
  "summary.noPages": "0 páginas",
  "summary.expeditedTurnaround": "Entrega urgente",
  "summary.expeditedPlusTurnaround": "Entrega Urgente Plus",
  "summary.discount": "Descuento",
  "summary.code": "código:",

  pages: ({ n }) => `${n} ${parseFloat(n) === 1 ? "página" : "páginas"}`,

  "button.continueDelivery": "Continuar a Entrega",
  "button.continueContact": "Continuar a Contacto",
  "button.continuePayment": "Continuar al pago",
  "button.continuing": "Un momento...",
  "button.waitingConnection": "Esperando conexión...",
  "button.backDetails": "Volver a Detalles",
  "button.backDelivery": "Volver a Entrega",
  "button.backContact": "Volver a Contacto",
  "button.save": "Guardar",
  "button.saving": "Guardando...",
  "button.cancel": "Cancelar",

  "field.firstName": "Nombre",
  "field.lastName": "Apellido",
  "field.email": "Correo electrónico",
  "email.typoCheck": "Revise su correo. ¿Quiso decir {fix}?",
  "email.typoFix": "Sí, usar ese",
  "field.optional": "(opcional)",

  "notify.error": "Error",
  "notify.success": "Listo",
  "notify.invalidEmail": "Correo no válido",
  "notify.fileRemoved": "Archivo eliminado",
  "error.generic": "Ocurrió un error al procesar la solicitud. Vuelva a intentarlo. Si el problema continúa, comuníquese con soporte.",
  "notify.orderNotSaved": "Su pedido no se guardó",
  "notify.quoteNotSent": "Su solicitud de cotización no se envió",
  "error.order.rejected": "Nuestro sistema no aceptó los datos de su pedido. Es un problema de nuestro lado y volver a intentarlo no lo va a resolver. Escríbanos a support@everbary.com y lo cargamos por usted.",
  "error.order.connection": "No pudimos conectarnos con nuestros servidores. Revise su conexión a internet y vuelva a intentarlo. Lo que ingresó sigue aquí.",
  "error.order.other": "Algo falló de nuestro lado. Vuelva a intentarlo. Si vuelve a ocurrir, escríbanos a support@everbary.com y lo cargamos por usted.",
  "error.order.clock": "La fecha o la hora de su dispositivo están mal y por eso nuestro sistema no puede aceptar su pedido. Corríjalas en la configuración del dispositivo y vuelva a intentarlo.",
  "notify.slowSave.title": "Esto está tardando más de lo normal",
  "notify.slowSave": "Revise su conexión a internet. Mantenga esta página abierta: seguimos solos apenas vuelva.",
  "error.order.number": "No pudimos obtener un número de pedido de nuestros servidores. Revise su conexión a internet y vuelva a intentarlo. Si vuelve a ocurrir, escríbanos a support@everbary.com.",
  "error.address.save": "No pudimos guardar este cambio en su dirección. Revise su conexión a internet y vuelva a intentarlo. Si vuelve a ocurrir, escríbanos a support@everbary.com.",
  "error.invalidEmail": "El correo electrónico no es válido. Revíselo y vuelva a intentarlo.",
  "error.missingData": "Esta página perdió los idiomas o la referencia de su pedido y no puede continuar. Vuelva al primer paso y revise sus documentos e idiomas.",

  missingFiles: ({ names }) => {
    const quoted = names.map((name) => `"${name}"`);
    const list = quoted.length > 1 ? `${quoted.slice(0, -1).join(", ")} y ${quoted[quoted.length - 1]}` : quoted[0];
    return names.length > 1
      ? `Los archivos ${list} ya no están cargados, así que los quitamos de su pedido. Vuelva a subirlos si necesita traducirlos.`
      : `El archivo ${list} ya no está cargado, así que lo quitamos de su pedido. Vuelva a subirlo si necesita traducirlo.`;
  },

  "secure.turnaround": "Plazo estimado: {time}",
  "secure.turnaroundText": "Es una estimación del plazo de entrega de la copia digital, según los datos del pedido que ingresó hasta ahora.",
  "secure.title": "Seguro y confidencial",
  "secure.text": "Todos los datos que procesa nuestro sitio, incluidos los archivos que sube, están cifrados. Solo el personal indispensable, con acuerdos de confidencialidad firmados, puede ver su información.",
  "secure.help": "¿Necesita ayuda?",
  "secure.contactUs": "Contáctenos",

  "bar.total": "Total",

  "select.search": "Buscar",
  "select.allLanguages": "Todos los idiomas",
  "select.noOptions": "No hay opciones",
  "select.youOrderMost": "Los que más pide",
  "select.mostRequested": "Los más pedidos",

  "more.options": "Más opciones",
  ordersCount: ({ n }) => `${n} ${n === 1 ? "pedido" : "pedidos"}`,

  "upload.select": "Elija un archivo",
  "upload.orDrag": "o arrástrelo hasta aquí",
  "upload.orPhoto": "o tome una foto",
  "upload.max": "El tamaño máximo por archivo es de 50 MB.",
  "upload.slow": "Su conexión parece lenta. El archivo se sigue subiendo…",
  "upload.stalled": "La subida parece trabada.",
  "upload.failed": "No se pudo subir el archivo.",
  "upload.retry": "Reintentar",
  "upload.tooBig": "Este archivo pesa {size} MB y es demasiado grande para subirlo (el máximo es 50 MB). Envíe uno más liviano o comprimido.",

  "nav.signOut": "Cerrar sesión",
  "nav.signedOut": "Cerró sesión.",
  "nav.signOutError": "Hubo un error al cerrar la sesión. Vuelva a intentarlo.",
  "chunk.failed": "No se pudo cargar esta página. Revise su conexión y vuelva a cargarla.",
  "chunk.reload": "Volver a cargar",

  "missing.intro": "Falta completar: {list}",
  // "y" turns into "e" before an "i" sound: "idioma de origen e idioma de destino".
  "missing.and": ({ next }) => (/^h?i(?!e)/i.test(next || "") ? "e" : "y"),
  "missing.more": "y {n} más",
  "missing.field.email": "correo electrónico",
  "missing.field.validEmail": "un correo electrónico válido",
  "missing.field.languageFrom": "idioma de origen",
  "missing.field.languageTo": "idioma de destino",
  "missing.field.files": "archivos para traducir",
  "missing.field.pages": "cantidad de páginas",
  "missing.field.firstName": "nombre",
  "missing.field.hear": "cómo se enteró de nosotros",
  "missing.field.hearOther": "dónde se enteró de nosotros",
  "missing.field.submittingTo": "quién le pide la traducción",
  "missing.field.submittingTo.attorney": "el nombre de su abogado",
  "missing.field.submittingTo.university": "el nombre de la universidad",
  "missing.field.submittingTo.dmv": "el estado del DMV",
  "missing.field.submittingTo.other": "quién se la pide",
  "missing.field.country": "país",
  "missing.field.method": "método de envío",
  "missing.field.state": "estado o provincia",
  "missing.field.city": "ciudad",
  "missing.field.zip": "código postal",
  "missing.field.street": "calle y número",
  "missing.field.savedAddress": "una dirección guardada",
  "missing.field.addressName": "nombre de la dirección",
  "missing.required": "Obligatorio: {label}.",
  "missing.error.submittingTo": "Indíquenos quién le pide esta traducción.",
  "missing.error.submittingTo-attorney": "Escriba el nombre del abogado o del estudio jurídico.",
  "missing.error.submittingTo-university": "Escriba el nombre de la universidad o escuela.",
  "missing.error.submittingTo-dmv": "Elija el estado del DMV.",
  "missing.error.submittingTo-other": "Escriba quién le pide esta traducción.",
  "missing.error.firstName": "Escriba su nombre.",
  "missing.error.hear": "Cuéntenos cómo se enteró de nosotros.",
  "missing.error.files": "Suba los archivos para traducir.",
};

// Brazilian Portuguese, "você".
const pt = {
  "common.moreBelow": "Continua abaixo",
  "step.details": "Detalhes",
  "step.options": "Entrega e extras",
  "step.contact": "Contato",
  "step.payment": "Pagamento",
  "step.placed": "Pedido realizado",

  "service.certified": "Tradução certificada",
  "service.standard": "Tradução padrão",
  "service.notarization": "Notarização",
  "service.hardCopy": "Cópia impressa pelo correio",
  "service.signature": "Assinatura exigida na entrega",
  "service.expedited": "Urgente",
  "service.expeditedPlus": "Urgente Plus",
  "service.standardDelivery": "Padrão",

  "summary.title": "RESUMO",
  "summary.services": "Serviços",
  "summary.total": "Total",
  "summary.free": "Grátis",
  // Language names are lowercase inside a sentence in Portuguese too ("De espanhol para inglês").
  "summary.pair": ({ from, to }) => `De ${lower(from)} para ${lower(to)}`,
  "summary.noPages": "0 páginas",
  "summary.expeditedTurnaround": "Entrega urgente",
  "summary.expeditedPlusTurnaround": "Entrega Urgente Plus",
  "summary.discount": "Desconto",
  "summary.code": "código:",

  pages: ({ n }) => `${n} ${parseFloat(n) === 1 ? "página" : "páginas"}`,

  "button.continueDelivery": "Continuar para Entrega",
  "button.continueContact": "Continuar para Contato",
  "button.continuePayment": "Continuar para o pagamento",
  "button.continuing": "Um momento...",
  "button.waitingConnection": "Aguardando conexão...",
  "button.backDetails": "Voltar para Detalhes",
  "button.backDelivery": "Voltar para Entrega",
  "button.backContact": "Voltar para Contato",
  "button.save": "Salvar",
  "button.saving": "Salvando...",
  "button.cancel": "Cancelar",

  "field.firstName": "Nome",
  "field.lastName": "Sobrenome",
  "field.email": "E-mail",
  "email.typoCheck": "Confira seu e-mail. Você quis dizer {fix}?",
  "email.typoFix": "Sim, usar esse",
  "field.optional": "(opcional)",

  "notify.error": "Erro",
  "notify.success": "Pronto",
  "notify.invalidEmail": "E-mail inválido",
  "notify.fileRemoved": "Arquivo removido",
  "error.generic": "Ocorreu um erro ao processar a solicitação. Tente novamente. Se o problema continuar, fale com o suporte.",
  "notify.orderNotSaved": "Seu pedido não foi salvo",
  "notify.quoteNotSent": "Sua solicitação de orçamento não foi enviada",
  "error.order.rejected": "Nosso sistema não aceitou os dados do seu pedido. O problema é do nosso lado e tentar de novo não vai resolver. Escreva para support@everbary.com e nós registramos o pedido para você.",
  "error.order.connection": "Não conseguimos nos conectar aos nossos servidores. Verifique sua conexão com a internet e tente novamente. O que você preencheu continua aqui.",
  "error.order.other": "Algo deu errado do nosso lado. Tente novamente. Se acontecer de novo, escreva para support@everbary.com e nós registramos o pedido para você.",
  "error.order.clock": "A data ou a hora do seu dispositivo está errada e, por isso, nosso sistema não consegue aceitar seu pedido. Corrija nas configurações do dispositivo e tente novamente.",
  "notify.slowSave.title": "Isso está demorando mais do que o normal",
  "notify.slowSave": "Verifique sua conexão com a internet. Mantenha esta página aberta: continuamos sozinhos assim que ela voltar.",
  "error.order.number": "Não conseguimos obter um número de pedido dos nossos servidores. Verifique sua conexão com a internet e tente novamente. Se acontecer de novo, escreva para support@everbary.com.",
  "error.address.save": "Não conseguimos salvar esta alteração no seu endereço. Verifique sua conexão com a internet e tente novamente. Se acontecer de novo, escreva para support@everbary.com.",
  "error.invalidEmail": "O e-mail não é válido. Confira e tente novamente.",
  "error.missingData": "Esta página perdeu os idiomas ou a referência do seu pedido e não pode continuar. Volte à primeira etapa e confira seus documentos e idiomas.",

  missingFiles: ({ names }) => {
    const quoted = names.map((name) => `"${name}"`);
    const list = quoted.length > 1 ? `${quoted.slice(0, -1).join(", ")} e ${quoted[quoted.length - 1]}` : quoted[0];
    return names.length > 1
      ? `Os arquivos ${list} não estão mais enviados, então nós os removemos do seu pedido. Envie-os de novo se precisar traduzi-los.`
      : `O arquivo ${list} não está mais enviado, então nós o removemos do seu pedido. Envie-o de novo se precisar traduzi-lo.`;
  },

  "secure.turnaround": "Prazo estimado: {time}",
  "secure.turnaroundText": "É uma estimativa do prazo de entrega da cópia digital, com base nos dados do pedido que você informou até agora.",
  "secure.title": "Seguro e confidencial",
  "secure.text": "Todos os dados processados pelo nosso site, incluindo os arquivos enviados, são criptografados. Somente a equipe indispensável, com acordos de confidencialidade assinados, pode acessar suas informações.",
  "secure.help": "Precisa de ajuda?",
  "secure.contactUs": "Fale conosco",

  "bar.total": "Total",

  "select.search": "Buscar",
  "select.allLanguages": "Todos os idiomas",
  "select.noOptions": "Nenhuma opção encontrada",
  "select.youOrderMost": "Os que você mais pede",
  "select.mostRequested": "Os mais pedidos",

  "more.options": "Mais opções",
  ordersCount: ({ n }) => `${n} ${n === 1 ? "pedido" : "pedidos"}`,

  "upload.select": "Escolher arquivo",
  "upload.orDrag": "ou arraste até aqui",
  "upload.orPhoto": "ou tire uma foto",
  "upload.max": "O tamanho máximo por arquivo é de 50 MB.",
  "upload.slow": "Sua conexão parece lenta. O arquivo continua sendo enviado…",
  "upload.stalled": "O envio parece travado.",
  "upload.failed": "Não foi possível enviar o arquivo.",
  "upload.retry": "Tentar de novo",
  "upload.tooBig": "Este arquivo tem {size} MB e é grande demais para enviar (o máximo é 50 MB). Envie um arquivo menor ou compactado.",

  "nav.signOut": "Sair",
  "nav.signedOut": "Você saiu da sua conta.",
  "nav.signOutError": "Houve um erro ao sair da conta. Tente novamente.",
  "chunk.failed": "Não foi possível carregar esta página. Verifique sua conexão e recarregue.",
  "chunk.reload": "Recarregar",

  "missing.intro": "Falta preencher: {list}",
  "missing.and": () => "e",
  "missing.more": "e mais {n}",
  "missing.field.email": "e-mail",
  "missing.field.validEmail": "um e-mail válido",
  "missing.field.languageFrom": "idioma de origem",
  "missing.field.languageTo": "idioma de destino",
  "missing.field.files": "arquivos para traduzir",
  "missing.field.pages": "número de páginas",
  "missing.field.firstName": "nome",
  "missing.field.hear": "como você nos conheceu",
  "missing.field.hearOther": "onde você nos conheceu",
  "missing.field.submittingTo": "quem está pedindo a tradução",
  "missing.field.submittingTo.attorney": "o nome do seu advogado",
  "missing.field.submittingTo.university": "o nome da universidade",
  "missing.field.submittingTo.dmv": "o estado do DMV",
  "missing.field.submittingTo.other": "quem está pedindo",
  "missing.field.country": "país",
  "missing.field.method": "forma de envio",
  "missing.field.state": "estado ou província",
  "missing.field.city": "cidade",
  "missing.field.zip": "CEP / código postal",
  "missing.field.street": "rua e número",
  "missing.field.savedAddress": "um endereço salvo",
  "missing.field.addressName": "nome do endereço",
  "missing.required": "Obrigatório: {label}.",
  "missing.error.submittingTo": "Diga quem está pedindo esta tradução.",
  "missing.error.submittingTo-attorney": "Digite o nome do advogado ou do escritório de advocacia.",
  "missing.error.submittingTo-university": "Digite o nome da universidade ou escola.",
  "missing.error.submittingTo-dmv": "Escolha o estado do DMV.",
  "missing.error.submittingTo-other": "Digite quem está pedindo esta tradução.",
  "missing.error.firstName": "Digite seu nome.",
  "missing.error.hear": "Conte como você nos conheceu.",
  "missing.error.files": "Envie os arquivos para traduzir.",
};

const texts = { en, es, pt };

export default texts;
